import Link from "next/link";

export function SiteFooter() {
  return (
    <footer className="bg-surface-container rounded-t-[2rem] mt-12">
      <div className="max-w-7xl mx-auto px-6 py-12 grid gap-10 md:grid-cols-4">
        <div>
          <Link
            href="/"
            className="font-headline text-headline-md text-garden-700 inline-block"
          >
            Esprit Potager
          </Link>
          <p className="mt-3 text-body-md text-on-surface-variant max-w-sm">
            Planifiez, cultivez, récoltez. Le compagnon potager qui vous suit
            toute l&apos;année.
          </p>
        </div>

        <div>
          <h3 className="text-label-lg uppercase tracking-wider text-on-surface-variant mb-4">
            Guides
          </h3>
          <ul className="space-y-2 text-body-md">
            <li>
              <Link href="/legumes" className="hover:text-garden-700 transition-colors">
                Fiches de culture
              </Link>
            </li>
            <li>
              <Link href="/calendrier" className="hover:text-garden-700 transition-colors">
                Calendrier du potager
              </Link>
            </li>
            <li>
              <Link href="/associations" className="hover:text-garden-700 transition-colors">
                Associations de plantes
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="text-label-lg uppercase tracking-wider text-on-surface-variant mb-4">
            Découvrir
          </h3>
          <ul className="space-y-2 text-body-md">
            <li>
              <Link href="/blog" className="hover:text-garden-700 transition-colors">
                Blog
              </Link>
            </li>
            <li>
              <Link href="/galerie" className="hover:text-garden-700 transition-colors">
                Galerie
              </Link>
            </li>
            <li>
              <Link href="/tarifs" className="hover:text-garden-700 transition-colors">
                Tarifs
              </Link>
            </li>
            <li>
              <Link href="/auth/signup" className="hover:text-garden-700 transition-colors">
                Créer un compte
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="text-label-lg uppercase tracking-wider text-on-surface-variant mb-4">
            Légal
          </h3>
          <ul className="space-y-2 text-body-md">
            <li>
              <Link href="/mentions-legales" className="hover:text-garden-700 transition-colors">
                Mentions légales
              </Link>
            </li>
            <li>
              <Link href="/cgu" className="hover:text-garden-700 transition-colors">
                CGU
              </Link>
            </li>
            <li>
              <Link href="/contact" className="hover:text-garden-700 transition-colors">
                Contact
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-outline-variant/15">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col sm:flex-row justify-between items-center gap-3 text-label-md text-on-surface-variant">
          <span>© {new Date().getFullYear()} SAS LM Phoenix — Tous droits réservés</span>
          <span className="text-garden-700">Fait avec 🌱 en France</span>
        </div>
      </div>
    </footer>
  );
}
